
import { VCardTitle } from "vuetify/lib";

// Functional component
export default VCardTitle;
